import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { API_VERSION, BASE_URL } from '../../../environments/environment';
import { NotificationsService } from 'angular2-notifications';
import { AccountApi } from '../../shared/sdk/services/custom';

@Component({
  selector: 'app-success-page',
  templateUrl: './success-page.component.html',
  styleUrls: ['./success-page.component.scss']
})
export class SuccessPageComponent implements OnInit {

  constructor(public http: Http, public router: Router, public location: Location) { }

  ngOnInit() {

  }

  onSubmit() {
  }
}





// WEBPACK FOOTER //
// ./src/app/app-modules/success-page/success-page.component.ts